import React, {memo} from 'react';

import {useNavPos} from '../../../hooks';

import Heart from './heart';
import Stars from '../../../ratings/components/stars';


function RatingWidget() {
	const navPos = useNavPos();

	let content = null;
	if(navPos.app && navPos.app.hearts) {
		content = (<Heart />);
	} else if(navPos.withStarsRating) {
		content = (<Stars />);
	}

	if(!content)
		return null;

	return (<div className="stade-widget stade-widget__rating">
		{content}
	</div>);
}

export default memo(RatingWidget);
